import { gql } from "@apollo/client";

const GET_CLIENT_MONITORING_EVENTS = gql`
  query getClientMonitoringEvents(
    $identifier: String!
    $isHandled: Boolean
    $skip: Int
    $take: Int
  ) {
    client(clientIdentifier: $identifier) {
      id
      name
      monitoringEvents(isHandled: $isHandled, skip: $skip, take: $take) {
        totalCount
        items {
          id
          clientIdentifier
          clientName
          descriptionLines
          detectedAt
          eventType
          handled
          handledAt
          parameterExclusionOptions {
            canSetExpirationDate
            latestAllowedExpirationDate
          }
          parameters {
            id
            title
            __typename
            exclusions {
              __typename
              id
              activeUntil
              activeUntilFurtherNotice
              createdAt
              isActive
              comment {
                id
                content
                createdAt
                createdByUser {
                  id
                  firstName
                }
              }
            }
          }
          comments {
            items {
              content
              createdAt
              createdByUser {
                id
                firstName
                lastName
              }
              id
            }
          }
        }
      }
    }
  }
`;

export default GET_CLIENT_MONITORING_EVENTS;
